import { Dispatch, SetStateAction } from "react";

import { handleMatch } from "utils/handleMatch";
import {
  ActionsSocketNames,
  InviteStatus,
  ISocketResponse,
  MessageActions,
  MessageTypeNames,
  TArgFuncSendMsg,
  TMessage,
  TMessageInvite,
  TMessageText,
} from "interfaces/interfacesChat";
import { convertTime } from "utils/helpers";
import { IMessageItem, TBodyMessage, TModeInvitation } from ".";
import { IMatchesEnum } from "interfaces/intarfaces";
import { StudentAPI } from "API/studentApi";
import { API_MATCHES } from "utils/constants";

const getText = (inputMsg: TBodyMessage): string => {
  switch (inputMsg.type) {
    case MessageTypeNames.TEXT_MSG:
      return inputMsg.body.text;
    case MessageTypeNames.INVITE_MSG:
      return Object.values(inputMsg.body.invite_dates).join(",");
    case MessageTypeNames.REMOVE_CHAT_MESSAGE:
      return inputMsg.body.text;
    default:
      return "";
  }
};

const getLastDate = (arrayMsg: IMessageItem[]): string =>
  arrayMsg
    .map((item) => item.created_at.length > 0 && item.created_at)
    .filter(Boolean)
    .slice(-1)[0] as string;

const isSameTime = (messages: IMessageItem[], date: string) =>
  !!messages.length && getLastDate(messages).slice(0, 16) === date.slice(0, 16);

const sortItemsMsg = (a: TMessage, b: TMessage) => {
  let aDate = a.created_at!,
    bDate = b.created_at!;
  if (aDate < bDate) return -1;
  if (aDate > bDate) return 1;
  return 0;
};

export const addMessageToList = (
  newMessage: ISocketResponse,
  messageData: IMessageItem[],
  setMessageData: Dispatch<SetStateAction<IMessageItem[]>>,
  handleMessage: TArgFuncSendMsg,
  user_id: string
) => {

  let dt = newMessage.body.created_at;
  let msg: IMessageItem = {
    body: {
      type: MessageTypeNames.TEXT_MSG,
      text: "Default text",
    },
    created_at: dt,
    chat_id: newMessage.body.chat_id,
    is_read: newMessage.body.is_read,
    isOwn: newMessage.body.author_id === user_id,
    label_time: isSameTime(messageData, dt) ? "" : convertTime(dt),
    updated_at: newMessage.body.updated_at,
    mode: "normal",
    handleMsg: handleMessage,
  };

  //@ts-ignore
  if(newMessage.action === ActionsSocketNames.INVITE_MESSAGE_CREATED && newMessage.body.body.invite_msg_status === 'rejected') {
   const toSend = {
    body: {type: 'text_message', text: 'invitation declined'},
    chat_id: newMessage.body.chat_id,
    created_at: newMessage.body.created_at,
     handleMsg: handleMessage,
    isOwn: false,
    is_read: false,
    label_time: "",
    mode: "normal",
    updated_at: newMessage.body.updated_at,
    }
    //@ts-ignore
        setMessageData((prev) => [...prev.filter((item) => item.body.type !== 'invite_message'), toSend]);
   return
    //@ts-ignore
  } else if(newMessage.action === ActionsSocketNames.INVITE_MESSAGE_CREATED && newMessage.body.body.invite_msg_status === 'accepted') {
    const toSend = {
      body: {type: 'text_message', text: 'invitation accepted'},
      chat_id: newMessage.body.chat_id,
      created_at: newMessage.body.created_at,
      handleMsg: handleMessage,
      isOwn: false,
      is_read: false,
      label_time: "",
      mode: "normal",
      updated_at: newMessage.body.updated_at,
    }
    //@ts-ignore
    setMessageData((prev) => [...prev.filter((item) => item.body.type !== 'invite_message'), toSend])
    return
  }

  switch (newMessage.action) {
    case ActionsSocketNames.TEXT_MESSAGE_CREATED:
      msg.body = {
        type: MessageTypeNames.TEXT_MSG,
        text: (newMessage.body.body as TMessageText).text,
      };
      setMessageData((prev) => [...prev, msg]);
      break;
    case ActionsSocketNames.TEXT_MESSAGE_UPDATED:
      msg.body = {
        type: MessageTypeNames.TEXT_MSG,
        text: (newMessage.body.body as TMessageText).text,
      };
      msg.mode = "edited";
      setMessageData((prev) =>
        prev.map((item) =>
          item.created_at === newMessage.body.created_at ? msg : item
        )
      );
      break;
    case ActionsSocketNames.TEXT_MESSAGE_DELETED:
      msg.body = {
        type: MessageTypeNames.TEXT_MSG,
        text: (newMessage.body.body as TMessageText).text,
      };
      msg.mode = "deleted";
      setMessageData((prev) =>
        prev.map((item) =>
          item.created_at === newMessage.body.created_at ? msg : item
        )
      );
      break;
    case ActionsSocketNames.INVITE_MESSAGE_DELETED:
      //@ts-ignore
      setMessageData((prev) => [...prev.filter((item) => item.body.created_at !== newMessage.body.created_at)])
      break;
    case ActionsSocketNames.INVITE_MESSAGE_CREATED:
      msg.body = {
        type: MessageTypeNames.INVITE_MSG,
        text:
          (newMessage.body.body as TMessageInvite).invite_msg_status ===
          InviteStatus.REMOVED
            ? "removeTenant"
            : getText({
                type: MessageTypeNames.INVITE_MSG,
                body: newMessage.body.body as TMessageInvite,
              }),
      };
      setMessageData((prev) => [...prev, msg]);
      break;
  }
};

export const updateMessageList = (
  isNewChat: boolean,
  messageData: IMessageItem[],
  messages: TMessage[],
  handleMessage: TArgFuncSendMsg,
  user_id: string
): [minDate: string, newArray: IMessageItem[]] => {
  let minDate = "";
  let tempArray: IMessageItem[] = [];
  messages.sort(sortItemsMsg).forEach((item, index) => {
    if (!index) minDate = item.created_at!;
    // if (
    //   item.msg_type === MessageTypeNames.INVITE_MSG &&
    //   ![InviteStatus.CREATED, InviteStatus.REMOVED, InviteStatus.ACCEPTED].includes(
    //     (item.body as TMessageInvite).invite_msg_status
    //   )
    // ) {
    //   console.log(item.msg_type === MessageTypeNames.INVITE_MSG, (item.body as TMessageInvite).invite_msg_status)
    // }

    tempArray.push({
      body: {
        //@ts-ignore
        type: (item.msg_type === 'invite_message' && (item.body.invite_msg_status === 'rejected' || item.body.invite_msg_status === 'accepted')) ? 'text_message' : item.msg_type,
        text:
        //@ts-ignore
            (item.msg_type === 'invite_message' && item.body.invite_msg_status === 'rejected') ? ('invitation declined') : (item.msg_type === 'invite_message' && item.body.invite_msg_status === 'accepted') ? ('invitation accepted') :
          (item.body as TMessageInvite).invite_msg_status ===
          InviteStatus.REMOVED
            ? "removeTenant"
            : getText({
                type: item.msg_type,
                body: item.body,
              } as TBodyMessage),
      },
      label_time: "",
      created_at: item.created_at,
      updated_at: item.updated_at,
      is_read: item.is_read,
      chat_id: item.chat_id,
      isOwn: item.author_id === user_id,
      mode: item.deleted
        ? "deleted"
        : item.created_at !== item.updated_at
        ? "edited"
        : "normal",
      handleMsg: handleMessage,
    });
  });
  let newArray: IMessageItem[] = [];
  [...tempArray, ...(isNewChat ? [] : messageData)].forEach((item) => {
    newArray.push({
      ...item,
      label_time: isSameTime(newArray, item.created_at!)
        ? ""
        : convertTime(item.created_at!),
    });
  });
  return [minDate, newArray];
};

export const transformInvitationToMsg = (
  mode: TModeInvitation,
  payload: IMatchesEnum,
  handleMessage: TArgFuncSendMsg,
  texts: { [keyName in TModeInvitation]: string },
  onError?: (error: string) => void
) => {
  switch (mode) {
    // This case for HOST
    case "cancelInvitation":
      handleMatch("rejectInvite", payload).then((response) => {
        if (response === 200) {
          handleMessage(texts[mode], MessageActions.MESSAGE_NEW);
        } else console.log("Error");
      });
      break;
    // This cases for STUDENT
    case "acceptOffer":
      StudentAPI.post(API_MATCHES + "accept-invite", payload).then(
        (response) => {
          if (response.success)
            handleMessage(texts[mode], MessageActions.MESSAGE_NEW);
          else {
            onError && onError(response.message as string)
            console.log("Error")
          };
        }
      );
      break;
    case "decline":
      StudentAPI.post(API_MATCHES + "reject-invite", payload).then(
        (response) => {
          if (response.success)
            handleMessage(texts[mode], MessageActions.MESSAGE_NEW);
          else console.log("Error decline");
        }
      );
      break;
  }
};
